<template>
  <nav aria-label="Breadcrumb">
    <ul class="text-sm">
      <li
        class="inline "
        v-for="item in items"
      >
        <nuxt-link
          v-if="item.path"
          :to="item.path"
          class="transition-colors"
        >
          {{ item.title }}
        </nuxt-link>
        <span v-else>
          {{ item.title }}
        </span> 
      </li>
    </ul>
  </nav>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue';

defineProps({
  items: {
    type: Array as PropType<Array<{ title: string, path?: string | undefined }>>,
    required: true
  }
})

</script>
<style lang="scss" scoped>
ul {
  li:not(:last-child) {
    &::after {
      content: '/';
      margin: 0 8px;
    }
  }
}
</style>